/*
 * @prettier
 * @copyright (c) 2019 - present, HGC-AB
 * @licence This source code is licensed under the MIT license described and found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'

// material-ui
import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import sitePrimary from '@material-ui/core/colors/teal'
//import sitePrimary from '@material-ui/core/colors/grey'
//import sitePrimary from '@material-ui/core/colors/grey'
import siteSecondary from '@material-ui/core/colors/deepOrange'
import siteBackground from '@material-ui/core/colors/grey'


/**
 * Site theme used for the site navigation
 */
const theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      light: sitePrimary[400],
      main: sitePrimary[700],
      dark: sitePrimary[800]
    },
    secondary: {
      light: siteSecondary[300],
      main: siteSecondary[500],
      dark: siteSecondary[700]
    },
    background: {
      default: siteBackground[100]
    }
  }
})

/**
 * Function ensuring we are wrapping the theme provider and the theme at the root element
 * @type {Function}
 */
const themeWrapper = ({ element }) => {
  // Instantiating store in `wrapRootElement` handler ensures:
  //  - there is fresh store for each SSR page
  //  - it will be called only once in browser, when React mounts
  return (
    <ThemeProvider theme={theme}>
      {/* CssBaseline kick start an elegant, consistent, and simple baseline to build upon. */}
      <CssBaseline />
      {element}
    </ThemeProvider>
  )
}

export default themeWrapper
